import { render, staticRenderFns } from "./ReagentSverka.vue?vue&type=template&id=210f53f9&scoped=true"
import script from "./ReagentSverka.vue?vue&type=script&lang=js"
export * from "./ReagentSverka.vue?vue&type=script&lang=js"
import style0 from "./ReagentSverka.vue?vue&type=style&index=0&id=210f53f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f53f9",
  null
  
)

export default component.exports